import React, { useEffect, useState } from "react";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import { Card, Typography, Button } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { colors } from "../../../constants/colors";
import RadioCustom from "../../../components/radio/RadioCustom";
import { advisorFormApi } from "../../../api/advisor-form/advisor-form.api";
import { advisorEstimateApi } from "../../../api/advisor-estimate/advisor-estimate.api";
import { unsetLoading } from "../../../store/loading/loading.slice";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { advisorStudentApi } from "../../../api/advisor-student/advisor-student.api";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import InputTextField from "../../../components/input/inputTextField";

interface DataChoice {
  label: string;
  value: string;
}

const dataChoices: DataChoice[] = [
  { label: "ดีมาก", value: "ดีมาก" },
  { label: "ดี", value: "ดี" },
  { label: "ปานกลาง", value: "ปานกลาง" },
  { label: "ควรปรับปรุง", value: "ควรปรับปรุง" },
];

interface AdvisorEstimateDetail {
  id_advisor_estimate_detail: number;
  id_advisor_estimate: number;
  id_advisor_form_detail: number;
  id_advisor_form_detail_sub: number;
  estimate_point: string;
  status: string;
}

const VotingEvaluation = () => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { profile } = useSelector((state: any) => state.profile);
  const { id } = useParams();
  const location = useLocation();

  const [dataEvaluationForm, setDataEvaluationForm] = useState<any[]>([]);
  const [selectedValues, setSelectedValues] = useState<any>({}); // Nested state to track selected values by detail and sub-detail ID
  const [singleData, setSingleData] = useState<any>({});
  const [remark, setRemark] = useState<string>("");

  const getSingleDataConsultation = async (id: number) => {
    const res = await advisorStudentApi.getAdvisorStudentById(id);
    const data = res.data;
    if (data.status < 300) {
      let parsedAdvisorStudentDetail = {} as any;
      try {
        parsedAdvisorStudentDetail = JSON.parse(
          data?.data.advisor_student_detaill
        );
      } catch (error) {
        console.error("Error parsing advisor_student_detaill:", error);
      }
      setSingleData(parsedAdvisorStudentDetail);
    }
  };

  const getSingleEvaluationForm = async (id: number) => {
    const res = await advisorFormApi.getAdvisorFormById(id);
    const data = res.data;
    if (data.status < 300) {
      return data.data;
    }
  };

  const fetchGetDataEvaluationFormById = async (id: number) => {
    const res = await advisorEstimateApi.getEstimateById(id);
    const data = res.data;

    if (data.status < 300) {
      if (data.data.id_advisor_form) {
        const structureForm = await getSingleEvaluationForm(
          data.data.id_advisor_form
        );

        if (
          structureForm?.advisor_form_detail &&
          data.data.id_advisor_estimate
        ) {
          // Setting the evaluation form data
          setDataEvaluationForm(structureForm?.advisor_form_detail ?? []);

          // Transform the structure to your save format
          const transformedData = {
            id_advisor_estimate: data.data.id_advisor_estimate,
            id_advisor_student: +id,
            remark: "string", // You may want to set this from your context
            status: "active", // Set appropriate status
            advisor_estimate_detail:
              data.data?.advisor_estimate_detail &&
              data.data?.advisor_estimate_detail.map((detail: any) => {
                return {
                  id_advisor_estimate_detail: detail.id_advisor_estimate_detail,
                  id_advisor_estimate: detail.id_advisor_estimate,
                  id_advisor_form_detail: detail.id_advisor_form_detail,
                  id_advisor_form_detail_sub: detail.id_advisor_form_detail_sub,
                  estimate_point: detail.estimate_point ?? null,
                  status: detail.status,
                };
              }),
          };

          console.log("Transformed Data:", transformedData);
          setSelectedValues(transformedData);
          // You can now use transformedData for saving
        }
      } else {
        setDataEvaluationForm([]);
        setSelectedValues({}); // Reset selected values if no data
      }
    } else {
      // Handle error response
      console.error("Failed to fetch data:", data.status);
    }
  };

  useEffect(() => {
    if (id) {
      fetchGetDataEvaluationFormById(+id);
      getSingleDataConsultation(+id);
    }
  }, [id]);
  // const updateEstimatePoint = (id: number, newEstimatePoint: string) => {
  //   setDataEvaluationForm((prevData) =>
  //     prevData.map((item) =>
  //       item.id_advisor_estimate_detail === id
  //         ? { ...item, estimate_point: newEstimatePoint }
  //         : item
  //     )
  //   );
  // };

  const handleRadioChange = (
    detailId: number,
    subDetailId: number,
    value: string
  ) => {
    setSelectedValues((prevValues: any) => {
      const updatedAdvisorEstimateDetail =
        prevValues.advisor_estimate_detail &&
        prevValues?.advisor_estimate_detail.map((item: any) =>
          item.id_advisor_form_detail === detailId &&
          item.id_advisor_form_detail_sub === subDetailId
            ? { ...item, estimate_point: value } // Update estimate_point with new value
            : item
        );

      return {
        ...prevValues,
        advisor_estimate_detail: updatedAdvisorEstimateDetail,
      };
    });
    // Optionally, update the estimate point if necessary
    // updateEstimatePoint(subDetailId, value); // Assuming you want to sync it
  };

  const handleUpdateStatus = async (id: number, prevData: any) => {
    if (profile && id) {
      try {
        const bodyJson = {
          ...prevData,
          last_updated_by: "student",
          status: "success",
        };

        const newBody = {
          advisor_student_detaill: JSON.stringify(bodyJson),
        };

        const response = await advisorStudentApi.updateAdvisorStudent(
          +id,
          newBody
        );

        if (response.status < 300) {
          alertSuccess(
            "จบการขอคำปรึกษา",
            "จบการขอคำปรึกษา เรียบร้อบแล้ว",
            undefined,
            () => {
              navigate(routeName.student.studentConsultation + `/${id}/update`);
            }
          );
        } else {
          alertError("จบการขอคำปรึกษา ไม่สำเร็จ");
        }
      } catch (error) {
        alertError("จบการขอคำปรึกษา ไม่สำเร็จ");
      } finally {
        dispatch(unsetLoading());
      }
    } else {
      alertError("ข้อมูลไม่ครบถ้วน");
    }
  };

  const submitEvaluation = async (id: number, bodyForm: any, prevData: any) => {
    try {
      dispatch(unsetLoading());
      // const advisorEstimateDetail: AdvisorEstimateDetail[] = [];

      // selectedValues?.advisor_estimate_detail &&
      //   selectedValues?.advisor_estimate_detail.forEach((detail: any) => {
      //     if (bodyForm[detail.id_advisor_form_detail]) {
      //       detail.advisor_form_detail_sub.forEach((subDetail: any) => {
      //         const selectedValue =
      //           bodyForm[detail.id_advisor_form_detail][
      //             subDetail.id_advisor_form_detail_sub
      //           ];
      //         if (selectedValue) {
      //           advisorEstimateDetail.push({
      //             // id_advisor_estimate_detail: number,
      //             // id_advisor_estimate: number,
      //             id_advisor_form_detail: detail.id_advisor_form_detail,
      //             id_advisor_form_detail_sub:
      //               subDetail.id_advisor_form_detail_sub,
      //             estimate_point: selectedValue,
      //             status: "active", // assuming "active" is the correct status
      //           });
      //         }
      //       });
      //     }
      //   });

      const body = {
        id_advisor_student: Number(id), // assuming `id` from useParams is the student ID
        id_advisor_estimate: selectedValues?.id_advisor_estimate,
        remark: remark,
        status: "active",
        advisor_estimate_detail: selectedValues?.advisor_estimate_detail,
      };
      // Call the API to submit the evaluation
      const response = await advisorEstimateApi.votingEstimate(id, body);
      if (response.status < 300) {
        handleUpdateStatus(id, prevData);
      } else {
        alertError("จบการขอคำปรึกษา ไม่สำเร็จ");
      }
    } catch (error) {
      alertError("จบการขอคำปรึกษา ไม่สำเร็จ");
    } finally {
      dispatch(unsetLoading());
    }
  };

  return (
    <div className="h-auto">
      <NavigateListCustom
        navigateData={[
          {
            name: "อาจารย์ที่ปรึกษา",
            key: "1",
            pathName: routeName.student.chooseAdvisor,
          },
          {
            name: "ส่งเรื่องขอคำปรึกษา",
            key: "2",
            pathName:
              routeName.student.studentConsultation + "/" + id + "/update",
          },
          {
            name: "จบการขอคำปรึกษา",
            key: "3",
            pathName: location.pathname,
          },
        ]}
      />
      {/* header */}
      <section className="my-4">
        <Typography variant="h3">จบการขอคำปรึกษา</Typography>
      </section>

      {dataEvaluationForm &&
        dataEvaluationForm.length > 0 &&
        dataEvaluationForm.map((detail: any) => (
          <div key={detail.id_advisor_form_detail}>
            {/* Main Title */}
            <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mb-4">
              <Card
                sx={{
                  boxShadow: `0px 5px ${colors.subPrimary}`,
                  padding: 2,
                  flexDirection: "row",
                  borderRadius: "12px",
                  border: "1px solid #E0E0E0",
                }}
              >
                <Typography variant="h4">
                  {detail.advisor_form_detail_name}
                </Typography>
              </Card>
            </article>

            {/* Sub Titles and Radio Selections */}
            {detail.advisor_form_detail_sub &&
              detail.advisor_form_detail_sub.length > 0 &&
              detail.advisor_form_detail_sub.map((subDetail: any) => {
                // Get the selected estimate_point value from selectedValues for this subDetail
                const selectedEstimatePoint =
                  selectedValues?.advisor_estimate_detail?.find(
                    (item: any) =>
                      item.id_advisor_form_detail ===
                        detail.id_advisor_form_detail &&
                      item.id_advisor_form_detail_sub ===
                        subDetail.id_advisor_form_detail_sub
                  )?.estimate_point || "";

                return (
                  <article
                    className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-8 mb-8"
                    key={subDetail.id_advisor_form_detail_sub}
                  >
                    <Card
                      sx={{
                        boxShadow: `0px 5px ${colors.subPrimary}`,
                        padding: 2,
                        flexDirection: "row",
                        borderRadius: "12px",
                        border: "1px solid #E0E0E0",
                      }}
                    >
                      <Typography variant="h4">
                        {subDetail.advisor_form_detail_sub_name}
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          marginTop: "16px",
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <RadioCustom
                          value={selectedEstimatePoint}
                          onChange={(e: any) =>
                            handleRadioChange(
                              detail.id_advisor_form_detail,
                              subDetail.id_advisor_form_detail_sub,
                              e.target.value
                            )
                          }
                          heading={"ตัวเลือก"}
                          sx={{ my: 1 }}
                          dataList={dataChoices}
                        />
                      </div>
                    </Card>
                  </article>
                );
              })}
          </div>
        ))}

      <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
        <InputTextField
          heading={"ผลสรุปของการแก้ปัญหา"}
          placeholder={"ระบุผลสรุปของการแก้ปัญหา"}
          value={remark}
          onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setRemark(e.target.value)
          }
          row={3}
          maxRows={5}
          disablePaddingMultiline
          multiline
          inputHeight={"auto"}
        />
      </article>

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <ButtonOutlined
          onClick={() => {
            navigate(routeName.student.chooseAdvisor);
          }}
          mode="del"
          buttonName="ยกเลิก"
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />

        <ButtonPrimary
          onClick={() => {
            if (id) {
              submitEvaluation(+id, selectedValues, singleData);
            }
          }}
          mode="success"
          buttonName="ยืนยัน"
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />
      </section>
    </div>
  );
};

export default VotingEvaluation;
